import React, { FC, useCallback, MouseEvent } from 'react';
import classNames from 'classnames';

import { StopPropagationWrapperProps } from './interfaces';

const StopPropagationWrapper: FC<StopPropagationWrapperProps> = ({ children, className }) => {
  const handlePreventEvent = useCallback(
    (e: MouseEvent<HTMLSpanElement>) => e?.stopPropagation(),
    []
  );

  return (
    <span className={classNames('stopPropagationWrapper', className)} onClick={handlePreventEvent}>
      {children}
    </span>
  );
};

export default StopPropagationWrapper;
